<script>
  import { Swiper } from 'swiper';
  import 'swiper/swiper.css';
  export default {
    name: 'SliderCard',
    props: {
      swiperId: {
        type: String,
        required: true,
      },
      width: {
        type: Number,
        default: 280,
      },
      height: {
        type: Number,
        default: 368,
      },
      /**
       * [{
       *  img: '',
       *  title: '',
       * }]
       */
      slides: {
        type: Array,
        required: true,
      },
    },
    data() {
      return {
        swiper: null,
      };
    },
    methods: {
      handleSwiperNavigation(isNext) {
        if (isNext) {
          this.swiper?.slideNext();
        } else {
          this.swiper?.slidePrev();
        }
      },
    },
    async mounted() {
      await this.$nextTick();
      this.swiper = new Swiper(`#${this.swiperId}.swiper`, {
        loop: true,
        speed: 1000,

        autoplay: { delay: 1000, pauseOnMouseEnter: false },
        slidesPerView: 1,
        breakpointsBase: 'container',
        spaceBetween: 0,
        autoHeight: true,
        breakpoints: {
          [this.width * 1.5]: {
            slidesPerView: 2,
          },
          [this.width * 2.5]: {
            slidesPerView: 3,
          },
        },
      });
    },
  };
</script>

<template>
  <div class="slider-wrapper">
    <div class="slider-navigation">
      <div class="prev" @click="handleSwiperNavigation()">
        <img v-reload-on-fail src="/images/svgs/arrow-left-02.svg" alt="prev" />
      </div>
      <div class="next" @click="handleSwiperNavigation(true)">
        <img v-reload-on-fail src="/images/svgs/arrow-left-02.svg" alt="next" />
      </div>
    </div>
    <div :id="swiperId" class="swiper slider-carousel">
      <div class="swiper-wrapper">
        <div
          v-for="(gameSlide, i) in slides"
          :key="gameSlide.img + i"
          class="slide cursor-pointer swiper-slide"
          @click="$emit('click', gameSlide)"
        >
          <slot>
            <div>
              <img v-reload-on-fail :src="gameSlide.img" :alt="gameSlide.title || 'Game Slide'" draggable="false" />
            </div>
          </slot>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
  .slider-wrapper {
    width: 70cqw;
    height: min-content;
    border-radius: 10px;
    background-color: #1c0630;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    justify-self: center;
    align-self: center;
    user-select: none;
    .slider-navigation {
      position: absolute;
      z-index: 2;
      width: calc(100% + 20px);
      display: flex;
      justify-content: space-between;
      pointer-events: none;
      div {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 60px;
        height: 60px;
        background-color: #fff;
        border-radius: 100%;
        cursor: pointer;
        pointer-events: initial;
        img {
          width: 24px;
          height: 24px;
        }
        &.next img {
          transform: rotate(180deg);
        }
      }
    }
    .slider-carousel {
      width: 100%;
      .slide {
        display: flex;
        justify-content: center;
        align-items: center;
        div {
          padding: 38px 24px;
          @media (min-width: 1200px) {
            padding: 38px 32px;
          }
          height: 100%;
          img {
            max-height: 100%;
          }
          will-change: transform;
          transition: transform 200ms ease-in-out;
          transform: scale(1);
          &:hover {
            transform: scale(1.05);
          }
        }
      }
    }
  }
</style>
